// extracted by mini-css-extract-plugin
export default {"pendingText":"PendingIndicator_pendingText__qaa3r"};